
import {defineComponent, getCurrentInstance, inject, onMounted, PropType, ref, Ref} from "vue";
import {attributeTypesValues} from "@/types/types";

export default defineComponent({
    name: "AttributeModal",
    props: {
        values: {
            required: true,
            type: Object as PropType<attributeTypesValues>
        },
        attr: {
            required: true,
            type: String
        }
    },
    setup(props) {
        const root = getCurrentInstance();

        const selectedElement: Ref<number> = ref(0);
        const isOpen: Ref<boolean> = ref(false);

        const selectedAttributes: Ref<Map<number, number | null>> | undefined = inject('selectedAttributes');

        const openModal = () => {
            isOpen.value = true;
        }

        const closeModal = () => {
            isOpen.value = false;
        }

        document.addEventListener('keyup', e => e.key === "Escape" && closeModal());

        const selectValue = (value) => {
            selectedElement.value = Number.parseInt(value);
            selectedAttributes && selectedAttributes.value.set(Number.parseInt(props.attr), selectedElement.value);

            closeModal();
        }

        onMounted(() => {
            // TODO
            /*
            root && root.$on("attributePricePredictionChanged", (predictor) => {
                this.values.forEach(e => {
                    let text = '&nbsp;';
                    const priceChange = predictor(Number.parseInt(this.$el.dataset.attribute), Number.parseInt(e.el.dataset.value));
                    if (priceChange && priceChange.price !== undefined && !priceChange.same) {
                        const parts = Math.abs(priceChange.price).toFixed(this.decimal).toString().split(".");
                        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                        const textToReplace = (priceChange.price >= 0 ? '+' : '-') + '&nbsp;' + parts.join(",");
                        text = this.priceTemplate.replace('{$price}', textToReplace);
                    } else if (!priceChange.same) {
                        text = this.unavailable;
                    }

                    e.priceEl.innerHTML = text;
            });
                }); */
        });

        return {
            selectedElement,
            isOpen,
            openModal,
            closeModal,
            selectValue
        }
    }
});
